<template>
  <!-- eslint-disable max-len -->
  <div>
    <v-data-table
      width="100%"
      height="70vh"
      :sort-by.sync="pagination.sortBy"
      :sort-desc.sync="pagination.descending"
      :items-per-page.sync="pagination.rowsPerPage"
      hide-default-footer
      fixed-header
      :headers="headers"
      :items="batches"
      class="table elevation-0"
    >
      <template v-slot:header="{ header }">
        <tr class="table__header-row">
          <th
            v-for="h in header"
            :key="h.text"
            :class="['table__header', h.text, isActions(h) ? 'column_sortable' : '', pagination.descending ? 'desc' : 'asc', h.value === pagination.sortBy ? 'active' : '']"
            @click="!isActions(h) ? changeSort(h.value) : () => {}"
          >
            {{ h.text }}
            <v-icon
              v-if="!pagination.descending && h.value === pagination.sortBy"
              class="table__header-icon"
              small
            >arrow_upward</v-icon>
            <v-icon
              v-if="pagination.descending && h.value === pagination.sortBy"
              class="table__header-icon"
              small
            >arrow_downward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:item="{ item }">
        <tr :class="[ 'table__row', !item.outputId ? 'table__processing' : '' ]" :key="item.id">
          <td class="table__cell date">
            {{ item.formattedDate }}
          </td>
          <!-- <td class="table__cell isUrgent"> -->
          <!--   <v-icon :id="'urgent-' + item.id" v-if="active" :color="'#cb201f'">mdi-alert-circle</v-icon> -->
          <!--   <v-icon v-if="!active" :color="'#a9a9a9'">mdi-alert-circle</v-icon> -->
          <!-- </td> -->
          <td class="table__cell">
            {{ shortFont(item.font) }}
          </td>
          <td class="table__cell download">
            <v-icon
              v-if="item.outputId"
              color="#000"
              @click="downloadDocument(item.outputId)"
            >mdi-download</v-icon>
          </td>
          <td>
            <button @click="deleteBatch(item)">
              <v-icon :color="'#cb201f'">mdi-delete</v-icon>
            </button>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <div v-if="loading">
          <span>Loading data, please wait...</span>
        </div>
        <div v-else>
          <span>No records available for this view</span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import API from '../services/API';

const ACTIONS = 'ACTIONS';

export default {
  name: 'Batches-Table',
  props: ['batches', 'loading'],
  components: {},
  data() {
    return {
      pagination: { sortBy: 'date', descending: true, rowsPerPage: -1 },
      active: true,
      headers: [
        {
          text: 'DATE PROCESSED',
          align: 'left',
          value: 'date',
        },
        { text: 'FONT', value: 'active' },
        { text: 'DOWNLOAD', value: 'admin' },
        { text: ACTIONS, value: 'admin' },
      ],
    };
  },
  methods: {
    isActions(header) {
      return header && header.text && header.text === ACTIONS;
    },

    shortFont(fontName) {
      if (!fontName) {
        return null;
      }

      return fontName.substr(0, 3);
    },

    deleteBatch(batch) {
      const willDelete = confirm('Are you sure you wish to delete this batch?');

      if (!willDelete) {
        return;
      }

      API.delete(`batches/${batch.id}`).then(() => {
        const index = this.batches.indexOf(batch);
        this.batches.splice(index, 1);
      });
    },

    changeSort(column) {
      console.log('sort by: ', column);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    downloadDocument(outputId) {
      console.log(outputId);
      API.get(`batches/pdf/${outputId}`).then((output) => {
        console.log(output);
        window.open(output.data.url, '_blank');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
tbody tr:nth-of-type(odd) {
  background-color: #f6f6f6;

  &:hover {
    background-color: #f6f6f6 !important;
  }
}

tbody tr:nth-of-type(even) {
  &:hover {
    background-color: #fff !important;
  }
}

.modal-btn {
  font-family: Heebo;
  letter-spacing: 0.5px;
  font-size: 1.5rem;
  line-height: 24px;
  text-align: center;
  text-transform: none;
  width: 120px;

  &__container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 30px 5px 30px;
  }

  &.confirm {
    color: #fff;
  }
}

.table {
  width: 100%;

  .column_sortable {
    cursor: pointer;
  }

  &__header-row {
    border-bottom: 2px solid #a9a9a9 !important;
  }

  &__header {
    height: 2.1rem;
    color: #212121 !important;
    font-family: Heebo;
    font-size: 1.4rem !important;
    font-weight: bold;
    letter-spacing: 0.124rem;
    line-height: 2.1rem;
    text-align: left;
    padding: 0 0.5rem !important;

    &-icon {
      transform: translateY(-4px);
    }
  }

  &__processing {
    background-color: #fbb !important;
  }

  &__row {
    height: 5.2rem !important;
  }

  &__cell {
    color: #212121;
    font-family: Heebo;
    font-size: 1.4rem;
    line-height: 2.1rem;

    .checkbox-btn {
      background: transparent;
      outline: none;
    }
  }

  .download {
    padding-left: 4rem;
  }

  .isUrgent {
    padding-left: 6rem;
  }
}

.download {
  text-decoration: none;
}
</style>

